export enum Operator {
    GreaterThan = 0,
    GreaterThanEqual = 1,
    LessThan = 2,
    LessThanEqual = 3,
    Equal = 4,
    NotEqual = 5,
    Like = 6,
    iLike = 7,
    Between = 8,
    Text = 9,
    iText = 10,
    isNull = 11,
    Exists = 12,
    NotContains = 13,
    iNotContains = 14,
    NotExists = 15,
    MatchPhrasePrefix = 21,
    ContainsWord = 16,
}

export enum Logical {
    And = 1,
    Or = 2,
}

export enum FieldName {
    Date = 'date',
    Source = 'source',
    Location = 'location',
}

export interface Filter {
    name: string;
    values: string[];
    operator?: Operator;
    logical?: Logical;
    label?: string;
    locked?: boolean;
    all?: boolean; // ui - if all filter values are selected
    labels?: string[];
    allExplicit?: boolean; // ui - if all filter values are explicitly selected by user
}

export enum SortOrder {
    Asc = 1,
    Desc = 2,
}

export interface Sort {
    name: string;
    sortOrder: SortOrder;
}

export interface SearchRequest {
    filters: Filter[];
    pageIndex?: number;
    start?: number;
    count?: number;
    sorts?: Sort[];
    projections?: string[];
    exportOption?: boolean;
}

export interface MRRNotificationRequest {
    respondToReviewAgreementID: string;
}

export interface RequestHeader {
    agencyID: number;
    tenantID: number;
    userID: number;
    loggedTenantID: number;
    loggedUserID: number;
    allowStale: boolean;
}

export interface DeleteSourceListingsRequest {
    sourceID: string;
    pageIDs: string[];
    correlationID?: string;
}

export interface DeleteSourceListingsPayload {
    requestHeader: RequestHeader;
    deleteSourceListingsRequest: DeleteSourceListingsRequest;
}

export interface DeleteSourceListingsResponse {
    sourceID: string;
    operation: string;
    status: string;
    totalRequested: number;
    deleteListingResponses?: Array<{
        pageID: string;
        publishRecordID: string;
    }>;
    errorCode?: number;
    correlationID?: string;
    error?: {
        message: string;
    };
    errorMessage?: string;
}
